"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsPage = exports.SelectAction = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const licenses_1 = require("@completeanatomy/licenses");
const config_1 = require("@completeanatomy/config");
const i18n_1 = require("@completeanatomy/i18n");
const sharing_1 = require("@completeanatomy/sharing");
const ui_1 = require("@completeanatomy/ui");
const hocs_1 = require("../../hocs");
const hooks_1 = require("../../hooks");
const organisms_1 = require("../../organisms");
const EmptyListPlaceholder_1 = __importDefault(require("../../organisms/EmptyListPlaceholder"));
const index_1 = require("../../organisms/index");
const utils_1 = require("../../utils");
var SelectAction;
(function (SelectAction) {
    SelectAction["Select"] = "Select";
    SelectAction["Deselect"] = "Deselect";
})(SelectAction || (exports.SelectAction = SelectAction = {}));
// eslint-disable-next-line max-lines-per-function
function NotificationsTab({ className }) {
    const notificationService = (0, hooks_1.useNotificationsService)();
    const notifications = (0, hooks_1.useNotifications)();
    const transformedData = (0, utils_1.transformNotificationsData)(notifications || []);
    const [state, setState] = (0, react_1.useState)(transformedData);
    const { t } = (0, i18n_1.useTranslation)();
    (0, ui_1.usePageTitle)(t(i18n_1.Strings.pageTitle.notifications));
    (0, react_1.useEffect)(() => {
        if (notifications) {
            const unreadNotifications = (0, utils_1.getUnreadNotificationIDs)(notifications || []);
            if (unreadNotifications.length) {
                unreadNotifications.forEach(id => notificationService.markAsRead(id));
            }
        }
    }, [notificationService, notifications]);
    (0, react_1.useEffect)(() => {
        notificationService === null || notificationService === void 0 ? void 0 : notificationService.fetch();
    }, [notificationService]);
    (0, react_1.useEffect)(() => {
        setState(transformedData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notifications]);
    const licences = (0, licenses_1.useUserLicenses)();
    const trialLicense = licences === null || licences === void 0 ? void 0 : licences.find(licence => licence.type >= bridge_schema_1.LicenseType.TrialManual &&
        licence.type <= bridge_schema_1.LicenseType.TrialSpecialType3 &&
        licence.isActive);
    const hasCommonNotifications = Object.values(transformedData.extraData).filter(value => !(value === null || value === void 0 ? void 0 : value.important))
        .length > 1;
    const onSelectAll = (action) => {
        setState(prevState => {
            const { extraData: data } = (0, lodash_1.cloneDeep)(prevState);
            const extraData = Object.values(data).reduce((acc, notification) => {
                const { identifier, important } = notification;
                acc[identifier] = Object.assign(Object.assign({}, notification), { selected: action === SelectAction.Select && !important });
                return acc;
            }, {});
            const nextAction = action === SelectAction.Select
                ? SelectAction.Deselect
                : SelectAction.Select;
            return { extraData, nextAction };
        });
    };
    const onSelect = (identifier) => {
        setState(prevState => {
            const { extraData } = (0, lodash_1.cloneDeep)(prevState);
            extraData[identifier].selected = !extraData[identifier].selected;
            const nextAction = Object.values(extraData).some(notify => !notify.selected && !(notify === null || notify === void 0 ? void 0 : notify.important))
                ? SelectAction.Select
                : SelectAction.Deselect;
            return { extraData, nextAction };
        });
    };
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, "data-e2e": 'NotificationsTab_Container', children: !(notifications === null || notifications === void 0 ? void 0 : notifications.length) && !trialLicense ? ((0, jsx_runtime_1.jsx)(EmptyListPlaceholder_1.default, { "data-e2e": 'NotificationsTab_EmptyListPlaceholder' })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [trialLicense && (0, jsx_runtime_1.jsx)(organisms_1.TrialNotification, { license: trialLicense, "data-e2e": 'NotificationsTab_TrialNotification' }), hasCommonNotifications && ((0, jsx_runtime_1.jsx)(index_1.SelectNotifications, { onClick: onSelectAll, nextAction: state.nextAction, notificationsExtraData: state.extraData, "data-e2e": 'NotificationsTab_SelectNotifications' })), (0, jsx_runtime_1.jsx)(Scroll, { "data-e2e": 'NotificationsTab_Scroll', children: (0, jsx_runtime_1.jsx)(organisms_1.NotificationsList, { notificationsExtraData: state.extraData, notifications: notifications !== null && notifications !== void 0 ? notifications : [], onSelect: onSelect, "data-e2e": 'NotificationsTab_NotificationsList' }) })] })) }));
}
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.designSystem.background};
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  font-family: ${({ theme }) => theme.fontFamily}, sans-serif;
`;
const Scroll = (0, styled_components_1.default)(ui_1.ScrollView) `
  flex-direction: column;
  box-sizing: border-box;
  width: 100vw;
  height: calc(
    100% - env(safe-area-inset-top) - ${({ theme }) => theme.headerHeight}px
  );

  padding-bottom: env(safe-area-inset-bottom);

  overflow: hidden;
`;
exports.default = NotificationsTab;
exports.NotificationsPage = (0, config_1.withConfigProvider)((0, sharing_1.withSharingProvider)((0, hocs_1.withNotificationsProvider)(NotificationsTab)));
